import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = () => {
  const { user, token } = useAuth();

  // If no user or token, redirect to sign-in page
  if (!user || !token) {
    return <Navigate to="/auth/signin" replace />;
  }
 
  // Otherwise, render the protected route
  return <Outlet />;
};

export default PrivateRoute;
